/** @module SiteAdmin/SecurityRoleTooltip */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/locale"
], function(declare,String,locale) {
	return declare(String, {
		toTooltip: function(ctx, h, tooltip) {
			tooltip.setContent(locale.resource("RoleDesc_" + this._getValue(ctx, h)));
		}
	});
});
